export const VERTICAL_LIST = [
    'animals-and-pet-supplies',
    'arts-and-entertainment',
    'baby-and-toddler',
    'business-and-industrial',
    'cameras-and-optics',
    'electronics',
    'fashion-and-accessories',
    'food-beverages-and-tobacco',
    'furniture',
    'hardware',
    'health-and-beauty',
    'home-and-garden',
    'luggage-and-bags',
    'media',
    'office-supplies',
    'toys-and-games',
    'vehicles-and-parts',
];
export const VERTICALS = VERTICAL_LIST.map(vertical => ({
    key: vertical,
    label: `resource.vertical.options.${vertical}`,
}));
export const VERTICAL_DEFAULT = 'fashion-and-accessories';
